if (!customElements.get('arvada-load-more')) {
  customElements.define('arvada-load-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.link.setAttribute('role', 'button');
      this.abort = new AbortController();
      this.link.addEventListener('click', event => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load();
      }, { signal: this.abort.signal });
      this.link.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); this.load(); } }, { signal: this.abort.signal });
      document.addEventListener('input', event => {
        if (event.target.closest('facet-filters-form')) this.request?.abort();
      }, { capture: true, signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
    async load() {
      const container = this.closest('#ProductGridContainer');
      if (this.busy || container.querySelector('.collection.loading')) return;
      this.busy = true;
      this.link.setAttribute('aria-disabled', 'true');
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.request = new AbortController();
      const context = location.pathname + location.search;
      try {
        const url = new URL(this.link.href);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Product request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || context !== location.pathname + location.search || container.querySelector('.collection.loading')) return;
        const grid = container.querySelector('#product-grid');
        const incoming = doc.querySelector('#product-grid');
        if (!incoming || incoming.dataset.id !== grid.dataset.id || !incoming.children.length) throw new Error('Invalid product section');
        const cards = [...incoming.children];
        cards.forEach(card => {
          card.classList.remove('scroll-trigger', 'animate--slide-in');
          card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
          grid.append(card);
        });
        const next = doc.querySelector('arvada-load-more a');
        if (next) this.link.href = next.href;
        else this.link.hidden = true;
        this.status.textContent = this.dataset.loaded;
        const firstLink = [...cards[0].querySelectorAll('a[href]')].find(link => link.getClientRects().length);
        firstLink?.focus({ preventScroll: true });
      } catch (error) {
        this.status.textContent = error.name === 'AbortError' ? '' : this.dataset.error;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.link.removeAttribute('aria-disabled');
      }
    }
  });
}
if (!customElements.get('arvada-price-slider')) {
  customElements.define('arvada-price-slider', class extends HTMLElement {
    connectedCallback() {
      this.fields = [...this.previousElementSibling.querySelectorAll('input')];
      this.sliders = [...this.querySelectorAll('input[type="range"]')];
      this.abort = new AbortController();
      this.maximum = Number(this.dataset.max);
      const read = value => Number(String(value).replace(/\s/g, '').replace(',', '.'));
      const sync = () => {
        const low = this.fields[0].value === '' ? 0 : read(this.fields[0].value);
        const high = this.fields[1].value === '' ? this.maximum : read(this.fields[1].value);
        this.sliders[0].value = Number.isFinite(low) ? low : 0;
        this.sliders[1].value = Number.isFinite(high) ? Math.max(low, high) : this.maximum;
        this.paint();
      };
      this.fields.forEach(field => {
        field.addEventListener('input', () => { field.value = field.value.replace(/\s/g, '').replace(',', '.'); sync(); }, { signal: this.abort.signal });
        field.addEventListener('change', sync, { signal: this.abort.signal });
      });
      this.sliders.forEach((slider, index) => {
        slider.addEventListener('input', event => {
          event.stopPropagation();
          slider.value = index === 0 ? Math.min(Number(slider.value), Number(this.sliders[1].value)) : Math.max(Number(slider.value), Number(this.sliders[0].value));
          this.fields[index].value = slider.value;
          this.paint();
        }, { signal: this.abort.signal });
        slider.addEventListener('change', event => {
          event.stopPropagation();
          this.fields[index].dispatchEvent(new Event('change', { bubbles: true }));
          this.fields[index].dispatchEvent(new Event('input', { bubbles: true }));
        }, { signal: this.abort.signal });
        slider.disabled = this.maximum <= 0;
      });
      sync();
    }
    paint() {
      const low = Number(this.sliders[0].value), high = Number(this.sliders[1].value);
      this.style.setProperty('--av-low', `${this.maximum ? low / this.maximum * 100 : 0}%`);
      this.style.setProperty('--av-high', `${this.maximum ? high / this.maximum * 100 : 100}%`);
      this.sliders[0].setAttribute('aria-valuemax', high);
      this.sliders[1].setAttribute('aria-valuemin', low);
      this.sliders[0].style.zIndex = low >= this.maximum ? '3' : '1';
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
